<template>
    <ubi-page-container>
        <ubi-panel>
          <h1>{{ $t("layouts.socialNetworks") }}</h1>
          <el-dialog class="dialogFacebookPages" :visible.sync="dialogFacebookPages">
            <span slot="title">{{ $t("socialNetworks.dialogPagesSelection") }}</span>
            <span>
              <el-form>
                <el-radio-group v-model="choixFacebookPage">
                  <div v-for="page in pagesFacebook" :key="page.id">
                    <el-row>
                      <el-col :md="24">
                        <el-radio :label="page.id">
                          <span style="padding: 10px;"><img :src="'https://graph.facebook.com/' + page.id + '/picture?type=large'" width="40px" style="text-align: center; vertical-align: middle;" /></span>
                          <a :href="'https://www.facebook.com/' + page.id" target="_blank">{{ page.name }}</a>
                        </el-radio>
                      </el-col>
                    </el-row>
                  </div>
                </el-radio-group>
              </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="savePageFacebook"><span>{{ $t("portals.list.confirm") }}</span></el-button>
            </span>
          </el-dialog>
          <div v-loading="loadingStatus">
            <el-row class="network-line">
              <el-col :lg="12" style="text-align: center">
                <div v-if="possedeFacebook" class="checkFacebook">
                  <em class="el-icon-success text-success mr-2" style="font-size:1.9em;" />
                </div>
                <div v-else class="checkFacebook">
                  <em class="el-icon-error text-danger mr-2" style="font-size:1.9em;" />
                </div>
                <div class="network-icon">
                  <div v-if="possedeFacebook && !connexionFacebook" class="network-text-connect">
                    {{ $t("socialNetworks.messageFacebookAutologin") }}
                  </div>
                  <img alt="" :src="require(`@/assets/facebook-logo-5-1.png`)" height="130" />
                </div>
                <div :style="(possedeFacebook && !connexionFacebook) ? '' : 'display:none;'">
                  <FacebookLogin :on-success="handleFacebook"></FacebookLogin>
                </div>
                <div v-if="!possedeFacebook">
                  <router-link :to="{ name: 'nousContacter' }" class="el-button inline el-button--primary" style="text-decoration: none;">
                    <span index="/contact" class="Route" @click="eventAnalytics('nous_contacter')">
                      <span class="Route-title">{{ $t("layouts.contactUs") }}</span>
                    </span>
                  </router-link>
                </div>
                <div v-if="pagesFacebook && pagesFacebook.length === 1">
                  <div style="font-weight: bold;">{{ $t("socialNetworks.titleFacebookPages") }}</div>
                  <div v-for="page in pagesFacebook" :key="page.id">
                    <div>
                      <span style="padding: 10px;"><img :src="'https://graph.facebook.com/' + page.id + '/picture?type=large'" width="40px" style="text-align: center; vertical-align: middle;" /></span>
                      <a :href="'https://www.facebook.com/' + page.id" target="_blank">{{ page.name }}</a>
                    </div>
                  </div>
                  <br />
                  <div><el-button @click="deconnexionFacebook" type="primary" class="inline">{{ $t("socialNetworks.facebookDeconnexion") }}</el-button></div>
                </div>
              </el-col>
              <el-col :lg="12" style="text-align: center">
                <div v-if="possedeInstagram" class="checkFacebook">
                  <em class="el-icon-success text-success mr-2" style="font-size:1.9em;" />
                </div>
                <div v-else class="checkFacebook">
                  <em class="el-icon-error text-danger mr-2" style="font-size:1.9em;" />
                </div>
                <div class="network-icon">
                  <div v-if="possedeInstagram && !connexionFacebook" class="network-text-connect">
                    {{ $t("socialNetworks.messageFacebookAutologin") }}
                  </div>
                  <img alt="" :src="require(`@/assets/2048px-Instagram_icon.png`)" height="130" />
                </div>
                <div :style="(possedeInstagram && !connexionFacebook) ? '' : 'display:none;'">
                  <FacebookLogin :on-success="handleFacebook"></FacebookLogin>
                </div>
                <div v-if="!possedeInstagram">
                  <router-link :to="{ name: 'nousContacter' }" class="el-button inline el-button--primary" style="text-decoration: none;">
                    <span index="/contact" class="Route" @click="eventAnalytics('nous_contacter')">
                      <span class="Route-title">{{ $t("layouts.contactUs") }}</span>
                    </span>
                  </router-link>
                </div>
                <div v-if="pagesInstagram && pagesInstagram.length > 0">
                  <div style="font-weight: bold;">{{ $t("socialNetworks.titleFacebookPages") }}</div>
                  <div v-for="page in pagesInstagram" :key="page.id">
                    <div>
                      <span style="padding: 10px;"><img :src="'' + page.profile_picture_url + ''" width="40px" style="text-align: center; vertical-align: middle; border-radius: 50%;" /></span>
                      <a :href="'https://www.instagram.com/' + page.username" target="_blank">{{ page.name }}</a>
                    </div>
                  </div>
                  <br />
                  <div><el-button @click="deconnexionFacebook" type="primary" class="inline">{{ $t("socialNetworks.facebookDeconnexion") }}</el-button></div>
                </div>
              </el-col>
            </el-row>
            <el-row class="network-line">
              <el-col :lg="12" style="text-align: center">
                <div v-if="possedeLinkedin" class="checkFacebook">
                  <em class="el-icon-success text-success mr-2" style="font-size:1.9em;" />
                </div>
                <div v-else class="checkFacebook">
                  <em class="el-icon-error text-danger mr-2" style="font-size:1.9em;" />
                </div>
                <div class="network-icon">
                  <img alt="" :src="require(`@/assets/linkedin-logo.png`)" height="130" />
                </div>
                <div v-if="possedeLinkedin && connexionLinkedin">
                  <LinkedInLogin></LinkedInLogin>
                </div>
                <div v-if="!possedeLinkedin">
                  <router-link :to="{ name: 'nousContacter' }" class="el-button inline el-button--primary" style="text-decoration: none;">
                    <span index="/contact" class="Route" @click="eventAnalytics('nous_contacter')">
                      <span class="Route-title">{{ $t("layouts.contactUs") }}</span>
                    </span>
                  </router-link>
                </div>
              </el-col>
              <el-col :lg="12" style="text-align: center">
                <div v-if="possedeGmb" class="checkFacebook">
                  <em class="el-icon-success text-success mr-2" style="font-size:1.9em;" />
                </div>
                <div v-else class="checkFacebook">
                  <em class="el-icon-error text-danger mr-2" style="font-size:1.9em;" />
                </div>
                <div class="network-icon">
                  <img alt="" :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)" height="130" />
                </div>
                <div v-if="!possedeGmb">
                  <router-link :to="{ name: 'nousContacter' }" class="el-button inline el-button--primary" style="text-decoration: none;">
                    <span index="/contact" class="Route" @click="eventAnalytics('nous_contacter')">
                      <span class="Route-title">{{ $t("layouts.contactUs") }}</span>
                    </span>
                  </router-link>
                </div>
                <div v-else>
                  <GoogleLogin></GoogleLogin>
                </div>
              </el-col>
            </el-row>
          </div>
        </ubi-panel>
    </ubi-page-container>
</template>

<script>

import {
  disconnectFacebook,
  issetTokenUtilisateur,
  recordDiffusionsMeta
} from '@/services/tokenUtilisateurApi'
import facebookLogin from '@/components/FacebookLogin'
import linkedinLogin from '@/components/LinkedInLogin'
import googleLogin from '@/components/GoogleLogin.vue'
import { getDiffusionAnnonceurByCodeName } from '@/services/portals'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  name: 'social-networks',
  components: {
    FacebookLogin: facebookLogin,
    LinkedInLogin: linkedinLogin,
    GoogleLogin: googleLogin
  },
  data () {
    return {
      loadingStatus: false,
      connexionFacebook: false,
      facebookData: {
        pages: {}
      },
      pagesFacebook: [],
      pagesInstagram: [],
      facebookIds: [],
      instagramIds: {},
      facebookUserId: null,
      dialogFacebookPages: false,
      choixFacebookPage: null
    }
  },
  computed: {
    user () {
      return this.$store.state.app.user
    },
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    },
    possedeFacebook () {
      return this.user.haveFacebook || this.user.haveFacebookBV
    },
    possedeInstagram () {
      return this.user.possedeInstagram || this.user.haveInstagramBV
    },
    possedeLinkedin () {
      return this.user.haveLinkedIn || this.user.haveLinkedInBV
    },
    possedeGmb () {
      return this.user.haveGMB || this.user.haveGMBBV
    },
    connexionLinkedin () {
      return this.sitimmoUser.linkedinUrlConnexion
    }
  },
  beforeMount () {
    this.handleFacebook()
  },
  methods: {
    async handleFacebook () {
      this.loadingStatus = true
      this.connexionFacebook = false
      this.pagesFacebook.splice(0)
      this.pagesInstagram.splice(0)
      this.facebookIds.splice(0)
      this.instagramIds = {}

      if (this.possedeFacebook || this.possedeInstagram) {
        const issetToken = await issetTokenUtilisateur()
        if (issetToken.isset_token === true) {
          const facebookPageId = await this.getFacebookPageId()
          // On vide le tableau
          this.pagesFacebook.splice(0, this.pagesFacebook.length)
          const facebookInfos = await this.getInfosFacebook()
          const facebookPages = facebookInfos.pages
          if (!facebookPageId || (facebookPageId == 'default_value')) {
            this.pagesFacebook = this.pagesFacebook.concat(facebookPages)
            if (facebookPages.length === 0) {
              // todo error on screen
            } else {
              for (let i = 0; i < facebookPages.length; i++) {
                const dataPage = facebookPages[i]
                this.facebookIds.push(dataPage.id)
                if (dataPage.instagram_business_account && dataPage.instagram_business_account.id) {
                  this.instagramIds[dataPage.id] = dataPage.instagram_business_account.id
                  this.pagesInstagram.push(dataPage.instagram_business_account)
                }
              }
              this.dialogFacebookPages = true
            }
          } else {
            this.connexionFacebook = true
            for (let i = 0; i < facebookPages.length; i++) {
              const dataPage = facebookPages[i]
              if (dataPage.id == facebookPageId) {
                this.pagesFacebook.push(dataPage)
                this.facebookIds.push(facebookPageId)
                if (dataPage.instagram_business_account && dataPage.instagram_business_account.id) {
                  this.instagramIds[dataPage.id] = dataPage.instagram_business_account.id
                  this.pagesInstagram.push(dataPage.instagram_business_account)
                }
              }
            }
          }
        }
      }
      this.loadingStatus = false
    },
    async getInfosFacebook () {
      const facebookPages = HTTP_HYPER_ESPACE_BACKEND.get('/facebook/infos').then(response => {
        return response.data
      }).catch(error => {
        console.log('getInfosFacebook: ' + error)
      })
      return facebookPages
    },
    async savePageFacebook () {
      if (this.choixFacebookPage) {
        this.loadingStatus = true
        this.dialogFacebookPages = false
        let instaId = null
        if (this.instagramIds[this.choixFacebookPage]) {
          instaId = this.instagramIds[this.choixFacebookPage]
        }
        await recordDiffusionsMeta(this.facebookUserId, instaId, this.choixFacebookPage)
        await this.handleFacebook()
        this.loadingStatus = false
      }
    },
    async deconnexionFacebook () {
      this.loadingStatus = true
      await disconnectFacebook()
      await this.handleFacebook()
      this.loadingStatus = false
    },
    async getFacebookPageId () {
      let facebookPageId = ''
      const facebookData = this.user.socialNetworkCodenames.find((element) => element[1].includes('FACEBOOK'))
      if (facebookData && facebookData[1]) {
        const facebookDiffusion = await getDiffusionAnnonceurByCodeName(facebookData[1])
        if (facebookDiffusion) {
          facebookPageId = facebookDiffusion.infos._embedded.diffusion_annonceur[0].identifiants[1].valeur
        }
      } else {
        const instagramData = this.user.socialNetworkCodenames.find((element) => element[1].includes('INSTAGRAM'))
        if (instagramData && instagramData[1]) {
          const instagramDiffusion = await getDiffusionAnnonceurByCodeName(instagramData[1])
          if (instagramDiffusion) {
            facebookPageId = instagramDiffusion.infos._embedded.diffusion_annonceur[0].identifiants[3].valeur
          }
        }
      }
      return facebookPageId
    },
    eventAnalytics (category) {
      this.$ga.event('navigation_permanente', 'clic', category, this.sitimmoUser.id)
    }
  }
}
</script>

<style>
  .checkFacebook {
    position: relative;
    margin-left: 33%;
    margin-bottom: -25px;
  }
  .network-icon {
    height: 135px;
  }
  .network-line {
    margin-bottom: 80px;
  }
  .network-text-connect {
    position: absolute;
    width: 140px;
    height: 140px;
    margin-left: 180px;
    background-color: white;
    opacity: 0.66;
  }
</style>
